import * as React from "react";
import { SVGProps } from "react";
const SvgDragndrop = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 29H13c-1.1 0-2-.9-2-2V13c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2ZM9 21H7c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v2h2V7c0-2.2-1.8-4-4-4H7C4.8 3 3 4.8 3 7v12c0 2.2 1.8 4 4 4h2v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDragndrop;
